export default {
  toast: {
    margin: '5.5rem 1rem 0 0',
    top: '0px',
    right: '0px',
    position: 'fixed',
    zIndex: 5600,
  },
};
